const Skillset = [
  {
    id: 1,
    name: 'JavaScript',
    type: 'Programming',
    img: 'js.png',
  },
  {
    id: 2,
    name: 'React',
    type: 'Frontend',
    img: 'react.png',
  },
  {
    id: 3,
    name: 'Redux',
    type: 'Frontend',
    img: 'redux.png',
  },
  {
    id: 4,
    name: 'Next Js',
    type: 'Frontend',
    img: 'next.png',
  },
  {
    id: 5,
    name: 'Node Js',
    type: 'Backend',
    img: 'node.png',
  },
  {
    id: 6,
    name: 'Express Js',
    type: 'Backend',
    img: 'express.png',
  },
  {
    id: 7,
    name: 'MongoDB',
    type: 'Backend',
    img: 'mongodb.png',
  },
  {
    id: 8,
    name: 'GitHub',
    type: 'Tools',
    img: 'github.png',
  },
  {
    id: 9,
    name: 'Jira',
    type: 'Tools',
    img: 'jira.png',
  },
  {
    id: 10,
    name: 'Slack',
    type: 'Tools',
    img: 'slack.png',
  },
  {
    id: 11,
    name: 'SASS',
    type: 'Frontend',
    img: 'sass.png',
  },
  {
    id: 12,
    name: 'HTML5',
    type: 'Frontend',
    img: 'html5.png',
  },
  {
    id: 44,
    name: 'CSS3',
    type: 'Frontend',
    img: 'css3.png',
  },
  {
    id: 13,
    name: 'Bootstrap',
    type: 'Frontend',
    img: 'bootstrap.png',
  },
  {
    id: 14,
    name: 'Python',
    type: 'Programming',
    img: 'python.png',
  },
  {
    id: 15,
    name: 'Material UI',
    type: 'Frontend',
    img: 'material.png',
  },
  {
    id: 16,
    name: 'Firebase',
    type: 'Tools',
    img: 'firebase.png',
  },
  {
    id: 17,
    name: 'C',
    type: 'Prgramming',
    img: 'c.png',
  },
  {
    id: 18,
    name: 'Heroku',
    type: 'Tools',
    img: 'heroku.png',
  },
  {
    id: 19,
    name: 'Miro',
    type: 'Tools',
    img: 'miro.png',
  },
  {
    id: 20,
    name: 'Php',
    type: 'Programming',
    img: 'php.png',
  },
]

export default Skillset